export const GET_NEW_BUSINESSES = 'NEW_BUSINESSES/get_new_businesses';
export const GET_SINGLE_NEW_BUSINESSES =
  'NEW_BUSINESSES/get_single_new_businesses';
export const UPDATE_NEW_BUSINESSES = 'NEW_BUSINESSES/update_new_businesses';
export const CREATE_NEW_BUSINESSES = 'NEW_BUSINESSES/create_new_businesses';
export const REMOVE_NEW_BUSINESSES = 'NEW_BUSINESSES/remove_new_businesses';

export const GET_NEW_BUSINESS_ACTIVITIES =
  'NEW_BUSINESS_ACTIVITIES/get_new_business_activities';
export const UPDATE_NEW_BUSINESS_ACTIVITIES =
  'NEW_BUSINESS_ACTIVITIES/update_new_business_activities';
export const CREATE_NEW_BUSINESS_ACTIVITIES =
  'NEW_BUSINESS_ACTIVITIES/create_new_business_activities';
export const REMOVE_NEW_BUSINESS_ACTIVITIES =
  'NEW_BUSINESS_ACTIVITIES/remove_new_business_activities';

export const GET_NEW_BUSINESS_NATURE_ID =
  'NEW_BUSINESS_ACTIVITIES/get_new_business_nature_id';
export const GET_NEW_BUSINESS_LINE_ID =
  'NEW_BUSINESS_ACTIVITIES/get_new_business_line_id';

export const GET_NECESSARY_FIELD_LIST =
  'NEW_BUSINESS_ACTIVITIES/get_necessary_field_list';

export const TOGGLE_ACTIVITY_RETIREMENT = `TOGGLE_ACTIVITY_RETIREMENT/toggle_activity_retirement`;

export const TOGGLE_BUSINESS_RETIREMENT = `TOGGLE_BUSINESS_RETIREMENT/toggle_business_retirement`;

export const GET_TAXPAYER_LIST = 'NEW_BUSINESSES/get_taxpayers_list';
export const HOLD_BUSINESS = 'NEW_BUSINESSES/hold_business';
export const GET_VETERINARY_FEE_LIST = 'NEW_BUSINESSES/get_veterinary_fee_list';
export const UPDATE_BUSINESS_ASSIGN = 'NEW_BUSINESSES/update_business_assign';
export const GET_BUSINESS_AUDIT_LOGS = 'NEW_BUSINESSES/get_business_audit_logs';
export const ADD_TAX_CREDIT = 'BUSINESS/add_tax_credit';
export const UPDATE_TAX_CREDIT = 'BUSINESS/update_tax_credit';
export const UPDATE_VETERINARY_FEE = 'BUSINESS/update_veterinary_fee';

export const FORM_DATA = {
  name: '',
  kind_of_ownership: '',
  bin: '',
  tin_no: '',
  dti_no: '',
  sec_no: '',
  cellphone_no: '',
  telephone_no: '',
  area_of_business_establishment: '',
  no_of_employees: '',
  taxpayer_id: '',
  region_code: '130000000',
  province_code: '133900000',
  municipality_code: '',
  barangay_code: '',
  street: '',
};

export const BUSINESS_ACTIVITIES_FORM_DATA = {
  business_nature_id: '',
  business_line_id: '',
  capital_amount: '',
  gross_amount: '',
  no_of_units: '',
  no_of_bed: '',
  area: '',
  no_od_booth: '',
  no_of_days: '',
  quantity: '',
  no_of_quarter: '',
  area_range: '',
  office_type: '',
};

export const KIND_OF_OWNERSHIP = [
  { label: 'SOLE PROPRIETORSHIP', value: 'SOLE PROPRIETORSHIP' },
  { label: 'ONE PERSON CORPORATION', value: 'ONE PERSON CORPORATION' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'CORPORATION', value: 'CORPORATION' },
  { label: 'COOPERATIVE', value: 'COOPERATIVE' },
];

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const OWNERS_GENDER = [
  { label: 'MALE', value: 'M' },
  { label: 'FEMALE', value: 'F' },
];
